<template>
    <div class="lease-management">
        <div class="lease-management-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LeaseManagement',
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
    .lease-management{
        position: relative;
        .lease-management-wrap{
            padding: 40px;
        }
    }
    @media screen and (max-width: 1280px){
        .lease-management{
            .lease-management-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/LeaseManagementPages/LeaseManagement.vue